import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "../../environments/environment";
import { Observable } from "rxjs";
import { Appointment, AuthPayload } from "../engine/models/models";
import { InspirationGallery } from "../models/InspirationGallery";
import { VideoType } from "../enum";
import { RequestAssistanceModal } from "../models/requestAssistanceModel";
@Injectable({ providedIn: "root" })

export class ContractService {
  constructor(private http: HttpClient) { }

  getInspirationRooms(contractId: number): Observable<InspirationGallery[]> {
    return this.http.get<InspirationGallery[]>(`${environment.api}/api/inspirationOverview/${contractId}`);
  }

  sendAssistanceRequest(model: RequestAssistanceModal): Observable<boolean> {
    return this.http.post<boolean>(`${environment.api}/api/appointment/sendRequestAssistance`, model);
  }
  //updateVideoWatched(contractId: number, videoType: number): Observable<any> {
  //  return this.http.get<any>(`${environment.api}/api/Appointment?contractId=${contractId}&videoType=${videoType}`);
  //}
  getAppointmentWithOptions(contractId: number, email: string, forceOptionRefresh: boolean, isRefreshCache): Observable<Appointment> {
    const payload = new AuthPayload();
    payload.contractId = contractId;
    payload.email = email;
    payload.includeOptions = true;

    // Used for getting the latest "Original" copy of the appointment
    payload.forceOptionRefresh = forceOptionRefresh;

    //will replace isSuccessful with other variable later.currntly used for testing purpose.
    if (isRefreshCache) { payload.isSuccessful = true; }
    return this.http.post<any>(`${environment.api}/api/options`, payload);
  }
}
